<script>
    import Label from './Label.svelte';

    export let label;
    export let value;
    export let labelWidth = '150px';
</script>

<div class="ro-field">
    <div class="ro-field__label" style="min-width: {labelWidth}">
        <Label label={label} />
    </div>

    <div class="ro-field__value">
        <Label label={value} />
    </div>
</div>

<style>
    .ro-field {
        display: flex;
        flex-direction: column;
    }

    .ro-field__label {
        color: var(--field-label-color);
    }
</style>
